import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useKitchenAuth } from '../context/KitchenAuthContext';

const KitchenPrivateRoute = ({ children }) => {
  const { isSeller, loading } = useKitchenAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '20px' }}>로딩중...</div>;
  }

  if (!isSeller) {
    return (
      <Navigate
        to="/kitchen/manage"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default KitchenPrivateRoute;